@let element = file();
@let safeIcon = icon();

@let DEBUG_LOCK = false;
@let isLocked = element.isLocked || DEBUG_LOCK;

<div
  class="file-item"
  [attr.data-size]="size()"
  [evcTooltipHover]="element.name"
  evcTooltipPlacement="bottom-start"
  evcTooltipDelay="300"
  [attr.disabled]="isLocked">
  <evc-icon
    class="icon"
    [file]="safeIcon"
    [size]="size()" />
  <span class="name ellipsis">{{ element.name }}</span>
  @if (element.isLocked || DEBUG_LOCK) {
    <evc-status-indicator
      class="tag"
      [text]="'list.menu.inUse' | translate"
      [status]="'warn'" />
  }
</div>
